import * as React from 'react'

import {
  Button,
  type ButtonProps,
  ChevronDownIcon,
  Flex,
  Label,
  Text,
} from '@buffer-mono/popcorn'

import { SCHEDULE_OPTIONS } from './constants'
import type { ScheduleSelectorState } from './types'

import styles from './ScheduleSelectorTrigger.module.css'

interface ScheduleOptionTriggerProps extends Omit<ButtonProps, 'children'> {
  currentSelection: ScheduleSelectorState
  formatTimestamp: (timestamp: number) => string
  children?: React.ReactNode
}

export const ScheduleOptionTrigger = React.forwardRef<
  HTMLButtonElement,
  ScheduleOptionTriggerProps
>(({ currentSelection, formatTimestamp, ...buttonProps }, ref) => {
  const { option, scheduledAt } = currentSelection
  const TriggerIcon = SCHEDULE_OPTIONS[option].icon
  const triggerLabel =
    option === 'FixedTime' && !!scheduledAt
      ? formatTimestamp(scheduledAt)
      : SCHEDULE_OPTIONS[option].label

  return (
    <Flex direction="column">
      <Label
        size="small"
        htmlFor="schedule-selector-trigger"
        className={styles.scheduleSelectorTriggerLabel}
      >
        When to Post
      </Label>
      <Button
        id="schedule-selector-trigger"
        ref={ref}
        className={styles.scheduleSelectorTrigger}
        variant="tertiary"
        size="large"
        {...buttonProps}
      >
        <Flex gap="2xs" direction="row" align="center">
          <TriggerIcon />
          <Text weight="medium">{triggerLabel}</Text>
          <ChevronDownIcon />
        </Flex>
      </Button>
    </Flex>
  )
})

ScheduleOptionTrigger.displayName = 'ScheduleOptionTrigger'
